import { Box, Checkbox, FormControlLabel } from '@mui/material';
import React, { useState } from 'react';
import SelectPopup from '../../../../Components/SelectPopup';
import FilterPopup from '../../../../Components/FilterPopup';
import { niches } from '../../../../Utils/constants';

export default function NichesFilter({ value, onChangeValue }) {
  const [internalSet, setInternalSet] = useState(new Set([]));

  const onOpen = () => {
    setInternalSet(new Set(value));
  };

  const onClear = () => {
    setInternalSet(new Set([]));
    onChangeValue(new Set([]));
  };

  const ToggleSet = (value) => {
    if (internalSet.has(value)) {
      setInternalSet((prevSet) => {
        prevSet.delete(value);
        return new Set(prevSet);
      });
    } else {
      setInternalSet((prevSet) => new Set(prevSet.add(value)));
    }
  };

  return (
    <SelectPopup
      value={Array.from(value).reduce((accum, value) => `${accum}${value}, `, '')}
      label="Niches"
      inputStyle={{ width: '7rem' }}
      onOpenPopup={onOpen}
    >
      <FilterPopup
        boxStyle={{
          padding: 2,
        }}
        onApply={() => {
          onChangeValue(new Set(internalSet));
          return true;
        }}
        onClear={onClear}
      >
        <Box
          sx={{
            width: { xs: '100%', sm: '15rem' },
            display: 'grid',
            height: 'max-content',
            justifyContent: 'start',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
            },
            gap: 0.5,
          }}
        >
          {niches.map((niche) => (
            <FormControlLabel
              key={niche}
              checked={internalSet.has(niche)}
              onChange={() => ToggleSet(niche)}
              label={niche}
              control={<Checkbox />}
              sx={{
                '& .MuiCheckbox-root': {
                  padding: { xs: 1.5, sm: 1 },
                },
              }}
            />
          ))}
        </Box>
      </FilterPopup>
    </SelectPopup>
  );
}
